export enum Drug {
  LESS_THAN_TWO_YEARS_AGO = 'LESS_THAN_TWO_YEARS_AGO',
  MORE_THAN_TWO_YEARS_AGO = 'MORE_THAN_TWO_YEARS_AGO',
  NO = 'NO',
}
